export const HTTPCONSTANTS = {
  protocol: '[HTTP-PROTOCOL]',
  odinBaseAddress: '[HTTP-ODIN-BASE-ADDRESS]',
  baseAddress: '[HTTP-BASE-ADDRESS]',
  xeroBaseAddress: '[HTTP-XERO-BASE-ADDRESS]',
  xeroProtocol: '[HTTP-XERO-PROTOCOL]'
};
